import { createAction } from "redux-actions";
import { apiGet, apiPost, apiPut, apiDelete } from "../../api/index";

import { urlForm, urlFormSecured, urlFormAllSecured } from "../../api/urls";

import {
  PAGE_SIZE_10,
  CREATE_FORM,
  GET_FORM,
  UPDATE_FORM,
  DELETE_FORM,
  FILTER_FORM,
} from "../../constants/index";

const generateFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.uuid !== undefined) filter += "&uuid=" + filters.uuid;
    if (filters.name !== undefined) filter += "&name=" + filters.name;
    if (filters.frontCode !== undefined)
      filter += "&frontCode=" + filters.frontCode;
    if (filters.personType !== undefined)
      filter += "&personType=" + filters.personType;
    if (filters.active !== undefined) filter += "&active=" + filters.active;
    if (filters.fields !== undefined) filter += "&fields=" + filters.fields;
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Get Form by uuid.
 */
export const getFormByUuid = createAction(GET_FORM, (param) =>
  apiGet(urlFormSecured, param, true)()
);

/**
 * Filter list Form.
 */
export const filterForm = createAction(FILTER_FORM, (filter, param) =>
  apiGet(urlFormSecured + generateFilterQuery(filter), param, true)()
);

/**
 * Create Form.
 */
export const createForm = createAction(CREATE_FORM, (obj) =>
  apiPost(urlFormSecured, obj, undefined, true)()
);

/**
 * Update Form.
 */
export const modifyForm = createAction(UPDATE_FORM, (obj, param) =>
  apiPut(urlFormSecured, obj, param, true)()
);

/**
 * Delete Form by uuid.
 */
export const removeForm = createAction(DELETE_FORM, (param) =>
  apiDelete(urlFormSecured, param, true)()
);

/**
 * Filter list Form.
 */
export const filterAllForm = createAction("FILTER_ALL_FORM", (filter) =>
  apiGet(urlFormAllSecured + generateFilterQuery(filter), undefined, true)()
);
